import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LockGlyph = /*#__PURE__*/createElement("g", {
  id: "lock",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  transform: "translate(15,10) scale(3.2)"
}, /*#__PURE__*/createElement("path", {
  d: "M9.70001 11.6252C9.70001 12.2544 9.35812 12.8037 8.85001 13.0978V14.1752C8.85001 14.6446 8.46947 15.0252 8.00001 15.0252C7.53055 15.0252 7.15001 14.6446 7.15001 14.1752V13.0978C6.64189 12.8037 6.30001 12.2544 6.30001 11.6252C6.30001 10.6864 7.06114 9.9252 8.00001 9.9252C8.93888 9.9252 9.70001 10.6864 9.70001 11.6252Z",
  strokeWidth: "0.5px"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00001 0.575195C11.2861 0.575195 13.95 3.23912 13.95 6.5252C14.8889 6.5252 15.65 7.28638 15.65 8.2252V16.7252C15.65 17.664 14.8889 18.4252 13.95 18.4252H2.05001C1.11114 18.4252 0.350006 17.664 0.350006 16.7252V8.2252C0.350006 7.28638 1.11114 6.5252 2.05001 6.5252C2.05001 3.23912 4.71393 0.575195 8.00001 0.575195ZM2.90001 6.5252H4.60001C4.60001 4.64735 6.12221 3.1252 8.00001 3.1252C9.8778 3.1252 11.4 4.64735 11.4 6.5252H13.1C13.1 3.70853 10.8167 1.4252 8.00001 1.4252C5.18334 1.4252 2.90001 3.70853 2.90001 6.5252ZM8.00001 3.9752C9.40834 3.9752 10.55 5.11697 10.55 6.5252H5.45001C5.45001 5.11697 6.59167 3.9752 8.00001 3.9752ZM1.20001 8.2252C1.20001 7.75579 1.58055 7.3752 2.05001 7.3752H13.95C14.4195 7.3752 14.8 7.75579 14.8 8.2252V16.7252C14.8 17.1946 14.4195 17.5752 13.95 17.5752H2.05001C1.58055 17.5752 1.20001 17.1946 1.20001 16.7252V8.2252Z",
  strokeWidth: "0.5px"
}));
const Lock = createSvg({
  name: 'lock',
  path: LockGlyph
});

export default Lock;
export { LockGlyph };
